import styled from '@emotion/styled';

export const QuickPickNameList = styled('ul', { label: 'QuickPickNameList' })`
    list-style-type: none;
    padding: 0;
    margin: 0;
    font-size: 0.85em;
    width: 220px;
    min-width: 220px;
    border-right: 1px solid #f0f0f0;
    background: #fafafa;
`;

export const QuickPickTitle = styled('li', { label: 'QuickPickTitle' })`
    position: relative;
    color: #575b58;
    padding: 1px 0 6px;
    line-height: 1.5em;
    height: 43px;
    min-height: 0;
    border-bottom: 0;
`;

interface QuickPickDetailsPropsType {
    hovered: boolean,
    nonRunner: boolean
}
export const QuickPickSelectionDetails = styled('li', { label: 'QuickPickSelectionDetails' })<QuickPickDetailsPropsType>`
    display: flex;
    flex-direction: row;
    margin-bottom: 1px;
    flex-wrap: nowrap;
    align-items: stretch;
    justify-content: space-between;
    height: 4.5em;
    min-height: 4.5em;
    font-size: 0.9em;
    background: ${({hovered}): string => hovered === true ? '#bbb' : '#fff'};
    border-bottom: 1px solid #f0f0f0;
    color: ${({hovered}): string => hovered === true ? '#fff' : 'inherit'};
    opacity: ${({nonRunner}): string => nonRunner === true ? '0.3' : '1'};
`;

export const TrapWrapper = styled('div', { label: 'TrapWrapper' })`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 50px;
`;
